import IntegrationApi from '../integration/integrationApi';
import {FormMultiPart} from '@/apis/base/httpclient';

class avaPlatformApi extends IntegrationApi {
  controllerName = 'AVA';

  async spellCheck(payload) {
    const request = {
      url: this.getAPIUrl() + '/spellCheck',
      data: payload,
    };
    return await this.postAsync(request);
  }

  // Lấy lại token AVA trường hợp dữ liệu context không có
  async refreshAVAConnect(payload) {
    const request = {
      url: this.getAPIUrl() + '/refreshAVAConnect',
      data: payload,
    };
    return await this.getAsync(request);
  }

  /**
   * chuyển giọng nói về API
   * @param {*} payload
   * @returns
   */
  async transferVoice(payload) {
    const request = {
      url: this.getAPIUrl() + '/transfers/voice',
      data: payload,
    };

    return await this.postAsync(request, true, true, FormMultiPart);
  }
}

export default new avaPlatformApi();
